import React, {Component, Fragment} from 'react';
import {Mutation} from 'react-apollo';
import gql from 'graphql-tag';
import {Button, ButtonPrimary} from '@homeaway/react-buttons';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import {queryParams, PAGINATED_TRIPBOARDS_QUERY} from '../../../tripboard/components/tripboards';
import EditName from '../../../tripboard/details/components/edit-name';
import edap from '../../../tripboard/edap';
import classnames from 'classnames';
import {withTranslationsAsProps} from '../../translations';

import './landing-page.less';

const CREATE_TRIPBOARD = gql`
    mutation createTripBoard($tripBoard: TripBoardInput!, $hav: String!) {
        createTripBoard(tripBoard: $tripBoard, hav: $hav) {
            uuid
            name
            createTime
            updateTime
            stay {
                dateRange {
                  arrival
                  departure
                }
            }
            user  {
                role {
                    type
                }
            }
            users {
                isMe
                role {
                    type
                }
                profile {
                    firstName
                    lastName
                    publicImageUrl
                }
            }
        }
    }
`;

const updateTripBoards = (hav, onDone = () => {}) => (proxy, {data}) => {
    const variables = queryParams(hav);
    const cache = proxy.readQuery({query: PAGINATED_TRIPBOARDS_QUERY, variables}) || {};
    if (data && data.createTripBoard && cache.paginatedTripBoards) {
        const {uuid} = data.createTripBoard;
        edap.tripboardCreate(uuid, 'empty');
        edap.boardSaved(uuid, 'empty');
        cache.paginatedTripBoards.tripBoards = [{...data.createTripBoard, listings: [], listingRefs: []}, ...cache.paginatedTripBoards.tripBoards];
    } else {
        edap.boardCreateError('empty');
    }

    proxy.writeQuery({query: PAGINATED_TRIPBOARDS_QUERY, variables, data: cache});
    onDone();
};

class LandingPage extends Component {
    constructor(props) {
        super(props);
        this.state = ({name: '', isNameChanged: false});
    }

    componentDidMount() {
        const {startTripboardCreation} = this.props;
        startTripboardCreation(); // callback; example usage: sets the redux flag to handle the routing to the newly created tripboard in onboarding
    }

    handleDone = () => {
        const {createTripBoard, hav} = this.props;
        const {name} = this.state;
        const tripBoard = {name};
        edap.boardCreate(name, 'empty');
        createTripBoard({variables: {tripBoard, hav}});
    }

    handleNameChange = ({isNameChanged, name}) => {
        this.setState({name, isNameChanged});
    }

    render() {
        const {isNameChanged, name} = this.state;
        const {loading = false, modalLayout, onCancel = () => {}, formLabel, cancelLabel, createLabel, isMobile} = this.props;

        return (
            <Fragment>
                <span className="landing-page__input">
                    <EditName
                        onDone={this.handleDone}
                        altLabel={formLabel}
                        onNameChange={this.handleNameChange}
                        isMobile={isMobile}
                    />
                </span>
                <div className={classnames('landing-page__button-container', {'button-container--modal': modalLayout})}>
                    <LoadingOverlay loading={loading} />
                        {modalLayout &&
                            <Button
                                label={cancelLabel}
                                className="landing-page__cancelbutton"
                                onClick={onCancel}
                                size={'sm'}
                            />
                        }
                        <ButtonPrimary
                            label={createLabel}
                            className="landing-page__button"
                            onClick={this.handleDone}
                            disabled={!isNameChanged || (name === '')}
                            size={'sm'}
                        />
                </div>
            </Fragment>
        );
    }
}

const handleMutationError = (onError = () => {}) => () => {
    edap.boardCreateError('empty');
    onError();
};

const LandingPageProvider = ({hav, startTripboardCreation = () => {}, onDone, onError, formLabel, cancelLabel, createLabel, modalLayout}) => {
    return (
        <Mutation mutation={CREATE_TRIPBOARD} update={updateTripBoards(hav, onDone)} onError={handleMutationError(onError)}>
            {(createTripBoard, {loading}) => {
                return (
                    <LandingPage formLabel={formLabel} cancelLabel={cancelLabel} createLabel={createLabel} createTripBoard={createTripBoard} hav={hav} startTripboardCreation={startTripboardCreation} loading={loading} onCancel={onDone} modalLayout={modalLayout}/>
                );
            }}
        </Mutation>
    );
};

export default withTranslationsAsProps({'tripboards.main.empty.board.prefill': 'formLabel', 'tripboards.cancel': 'cancelLabel', 'tripboards.main.empty.create': 'createLabel'})(LandingPageProvider);




// WEBPACK FOOTER //
// ./src/universal/components/onboarding/landing-page/landing-page.js